<div class="upload-modal-container">
  <div class="modal-header">
    <h2 class="ktitle-small">Upload Documents</h2>
    <p class="kbody-medium">{{ courseName }}</p>
  </div>

  <div class="modal-content">
<app-upload-file
  #uploader
  [fileTypeInS3]="'COURSE_DOCUMENT'"
  [courseItemId]="courseItemId"
  [courseRequestId]="requestId"
  [entityId]="entityId"
  [fillSpace]="false"
  (uploadComplete)="onUploadComplete()">
  <span overrideFooter class="kbody-small">
    PDF, XLS, DOC, DOCX, JPG, PNG or WebP (max 10 MB each)
  </span>
</app-upload-file>
  </div>
</div>